import Vue from 'vue';

let componentsStore = {
    "icon": "icon",
    "inputi": "inputi",
    "icheckbox": "icheckbox",
    "text-box": "textbox",
    "ilabel": "ilabel",
    "number-input": "number-input",
    "isection": "desktop/section",
    "btn": "button",
    "i-toggle": "itoggle",
    "i-date-picker": "i-date-picker",
    "i-svg": "i-components/i-svg",
    "i-markdown-editor": "i-components/i-markdown-editor",
    "i-admin-tools": "i-components/i-admin-tools",
    "i-smart-select": "i-components/i-smart-select",
    "i-modal-form": "i-components/i-modal-form",
    "i-multi-select": "i-components/i-multi-select",
    "i-photos": "i-components/i-photos",
    "i-posts": "i-components/i-posts",
    "i-list": "i-components/i-list",
    "i-prompt": "i-components/i-prompt",
    "i-list-editor": "i-components/i-list-editor",
    "tabs": "desktop/tabs",
    "tab": "desktop/tab",
    "i-uploader": "i-components/i-uploader",
    "i-video": "i-components/i-video",
    "i-image-viewer": "i-components/i-image-viewer",
    "i-notify": "i-components/i-notify",
    "i-loader": "i-components/i-loader-indicator",
    "i-loader-2": "i-components/i-loader-indicator",
    "i-button-toggle": "i-components/i-button-toggle",
    "i-currency": "i-components/i-currency",
    "i-map": "i-components/i-map",
    "i-dots": "i-components/i-dots",
    "i-tick-box": "i-components/i-tick-box",
    "i-font-tester": "i-components/i-font-tester",
    "i-lang-input": "i-components/i-lang-input",
    "i-td": "i-components/i-td",
    "dragger": "desktop/dragger",
    "dropper": "desktop/dropper",
    "back-to-top": "desktop/back-to-top",
    "loading-screen": "loading-screen",
    "imodal": "imodal",
    "modal": "desktop/modal",
    "modal-control-buttons": "i-components/i-modal-control-buttons",
    "i-modal": "i-components/i-modal",
    "panel": "desktop/panel",
    "list-select": "list-select",
    "select-tree": "select-tree",
    "auth": "desktop/auth",
    "multi-input": "i-components/multi-input",
    "i-form": "i-components/i-form",
    "i-wrapper": "desktop/i-wrapper",
    "i-wysiwyg": "i-components/i-wysiwyg2",
    "i-wysiwyg-service": "i-components/i-wysiwyg-service",
    "i-paginator": "i-components/i-paginator",
    "i-image-collection": "i-components/i-image-collection",
    "i-slide-show": "i-components/i-slide-show",
    "i-flip-clock": "i-components/i-flip-clock",
    "i-currency-input": "i-components/i-currency-input",
    "i-array-editor": "i-components/i-array-editor",
    "i-array-sort": "i-components/i-array-sort",
    "i-calendar": "i-components/i-calendar",
    "i-alert": "alert/alert",
}

let coreComponents = ["icon", "inputi", "btn", "text-box", "ilabel", "tab", "tabs", "list-select", 'i-modal-form'];

function importComponents(components) {
    components.forEach(async function(componentName) {
        let componentPath = componentsStore[componentName];
        Vue.component(componentName, async (resolve) => {
            let componentEl = await import(`../components/${componentPath}.vue`);
            resolve(componentEl);
        });
    });
}
importComponents(coreComponents);

Vue.importComponents = importComponents;

export default importComponents;

//Vue.component(componentName, componentEl);
/*
import Icon from "../components/icon.vue";
Vue.component('icon', Icon);

import Inputi from "../components/inputi.vue";
Vue.component('inputi', Inputi);

import Icheckbox from "../components/icheckbox.vue";
Vue.component('icheckbox', Icheckbox);

import Textbox from "../components/textbox.vue";
Vue.component('text-box', Textbox);

import Ilabel from "../components/ilabel.vue";
Vue.component('ilabel', Ilabel);

import NumberInput from "../components/number-input.vue";
Vue.component('number-input', NumberInput);

import iSection from "../components/desktop/section.vue";
Vue.component('isection', iSection);

import Button from "../components/button.vue";
Vue.component('btn', Button);

import iCheckbox from "../components/icheckbox.vue";
Vue.component("icheckbox", iCheckbox);

import iToggle from "../components/itoggle.vue";
Vue.component("i-toggle", iToggle);

import iDatePicker from "../components/i-date-picker.vue";
Vue.component("i-date-picker", iDatePicker);

import iList from "../components/i-components/i-list.vue";
Vue.component("i-list", iList);

import Tabs from "../components/desktop/tabs.vue";
Vue.component("tabs", Tabs);

import Tab from "../components/desktop/tab.vue";
Vue.component("tab", Tab);

import iUploader from "../components/i-components/i-uploader.vue";
Vue.component("i-uploader", iUploader);

import iVideo from "../components/i-components/i-video.vue";
Vue.component("i-video", iVideo);

import iImageViewer from "../components/i-components/i-image-viewer.vue";
Vue.component("i-image-viewer", iImageViewer);

import iLoader from "../components/i-components/i-loader-indicator.vue";
Vue.component("i-loader", iLoader);

import buttonToggle from "../components/i-components/i-button-toggle.vue";
Vue.component("i-button-toggle", buttonToggle);

import iCurrency from "../components/i-components/i-currency.vue";
Vue.component("i-currency", iCurrency);

import iMap from "../components/i-components/i-map.vue";
Vue.component("i-map", iMap);

import iDots from "../components/i-components/i-dots.vue";
Vue.component("i-dots", iDots);

import iTickBox from "../components/i-components/i-tick-box.vue";
Vue.component("i-tick-box", iTickBox);

import iFontTester from "../components/i-components/i-font-tester.vue";
Vue.component("i-font-tester", iFontTester);

import iLangInput from "../components/i-components/i-lang-input.vue";
Vue.component("i-lang-input", iLangInput);

import iTd from "../components/i-components/i-td.vue";
Vue.component("i-td", iTd);

import dragger from "../components/desktop/dragger.vue";
Vue.component("dragger", dragger);

import dropper from "../components/desktop/dropper.vue";
Vue.component("dropper", dropper);

import BackToTop from "../components/desktop/back-to-top.vue";
Vue.component('back-to-top', BackToTop);


import LoadingScreen from "../components/loading-screen.vue";
Vue.component('loading-screen', LoadingScreen);

import Imodal from  "../components/imodal.vue";
Vue.component('imodal', Imodal);

import Modal from "../components/desktop/modal.vue";
Vue.component('modal', Modal);

import ModalControl from "../components/i-components/i-modal-control-buttons.vue";
Vue.component('modal-control-buttons', ModalControl);

import panel from  "../components/desktop/panel.vue";
Vue.component('panel', panel);

import ListSelect from "../components/list-select.vue";
Vue.component('list-select', ListSelect);

import SelectTree from "../components/select-tree.vue";
Vue.component("select-tree",SelectTree);

import Auth from "../components/desktop/auth.vue";
Vue.component("auth", Auth);

import multiInput from "../components/i-components/multi-input.vue";
Vue.component("multi-input", multiInput);

import iForm from "../components/i-components/i-form.vue";
Vue.component("i-form", iForm);

import iWrapper from "../components/desktop/i-wrapper.vue";
Vue.component("i-wrapper",iWrapper);

import iWysiwyg from "../components/i-components/i-wysiwyg.vue";
Vue.component("i-wysiwyg", iWysiwyg);

import iPaginator from "../components/i-components/i-paginator.vue";
Vue.component("i-paginator", iPaginator);

import iImageCollection from "../components/i-components/i-image-collection.vue";
Vue.component("i-image-collection", iImageCollection);

import iSlideShow from "../components/i-components/i-slide-show.vue";
Vue.component("i-slide-show",iSlideShow);

//import iFlipClock from "../components/i-components/i-flip-clock.vue";
//Vue.component("i-flip-clock",iFlipClock);

import iCurrencyInput from "../components/i-components/i-currency-input.vue";
Vue.component("i-currency-input", iCurrencyInput);

import iArrayEditor from "../components/i-components/i-array-editor.vue";
Vue.component("i-array-editor", iArrayEditor);


import iArraySort from "../components/i-components/i-array-sort.vue";
Vue.component("i-array-sort", iArraySort);

import iCalendar from "../components/i-components/i-calendar.vue";
Vue.component("i-calendar",iCalendar);

import iAlert from "../components/alert/alert.vue";
Vue.component("i-alert",iAlert);*/